
export const PWD_MOBILE = "pwd_mobile";
export const PWD_IS_GET_CODE = "pwd_is_get_code";